import { Grid } from '@mui/material';
import { motion } from 'motion/react';
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { gameStyles } from '../../config/GameTheme';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { adaptTransition } from '../../util/Animation';
import { FullScreen, Widescreen } from '../layout/ScreenLayout';
import { FaceOffPortal } from './FaceOffPortal';
import { GameBoardZIndex } from './GameBoardZIndex';
import { StrikeOverlay } from './StrikeOverlay';

type Props = PropsWithChildren<{
	scores: ReactNode;
	question: ReactNode;
	strikes: ReactNode;
}>;

export const GameBoardLayout: FunctionComponent<Props> = (props) => {
	const phase = useGameplaySelector(gamePlayStore.selectors.phase);
	const isFaceOff = phase === 'faceoff';
	const scale = isFaceOff ? 0.8 : 1;

	return <FullScreen sx={[{ padding: 3 }, gameStyles.boardBackground]}>
		{props.children}
		<StrikeOverlay />
		<Widescreen>
			<Grid
				component={motion.div}
				initial={{ scale: 1 }}
				animate={{ scale }}
				transition={adaptTransition({ duration: 0.5, delay: 0.9 })}
				container
				columnSpacing={4}
				sx={{ height: '100%', paddingY: 4 }}
			>
				<Grid size={10} offset={1} sx={{ paddingX: 3, zIndex: GameBoardZIndex.Background }}>
					{props.scores}
				</Grid>

				<FaceOffPortal>
					<Grid size={10} offset={1} sx={{ zIndex: GameBoardZIndex.Content }}>
						{props.question}
					</Grid>

					{isFaceOff || <Grid size={1} sx={{
						display: 'flex',
						alignItems: 'center',
						minWidth: '80px',
					}}>
						{props.strikes}
					</Grid>}
				</FaceOffPortal>
			</Grid>
		</Widescreen >
	</FullScreen >;
};
